import { RefreshCcw } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface ScoringStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function ScoringStepSection({ workflow }: ScoringStepSectionProps) {
  const navigate = useNavigate()

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold">JFAC Scoring</h4>
      <p className="text-sm text-muted-foreground">
        Score findings using JFAC 2019 methodology and mission categorization.
      </p>
      {workflow.missionStats ? (
        <div className="grid gap-2 rounded-lg border border-border p-3 bg-muted/20">
          <div className="flex items-center justify-between text-sm">
            <span>Total Findings</span>
            <Badge variant="secondary">{workflow.missionStats.total_findings}</Badge>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span>Pending Vetting</span>
            <Badge variant="secondary">{workflow.missionStats.pending_vetting}</Badge>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground">
            <div>Critical: {workflow.missionStats.severity_counts.critical}</div>
            <div>High: {workflow.missionStats.severity_counts.high}</div>
            <div>Medium: {workflow.missionStats.severity_counts.medium}</div>
            <div>Low: {workflow.missionStats.severity_counts.low}</div>
          </div>
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">Select a mission to view scoring summary.</p>
      )}
      <Button variant="ghost" size="sm" onClick={() => workflow.refetchStats()}>
        <RefreshCcw className="mr-2 h-4 w-4" />
        {workflow.statsLoading ? 'Refreshing...' : 'Refresh Stats'}
      </Button>
      <Button variant="outline" onClick={() => navigate('/softwareiq/assurance/findings')}>
        View Findings
      </Button>
    </div>
  )
}
